module.exports = __webpack_public_path__ + "static/img/piliangshanchu2.035fa2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/piliangshanchu2.png
// module id = F4ie
// module chunks = 24